<template>
  <div class="solutions-ticket-list">
    <table>
      <thead v-if="!IsMobile">
        <tr>
          <th v-if="!IsMobile">{{ $t("ticketsList.default.created_at") }}</th>
          <th>{{ $t("ticketsList.default.title") }}</th>
          <th>{{ $t("ticketsList.default.request") }}</th>
          <th>{{ $t("ticketsList.default.solution") }}</th>
          <th v-if="!IsMobile">{{ $t("ticketsList.default.status") }}</th>
          <th v-if="!IsMobile" class="refreshList">
            <span
              class="material-icons"
              @click="getTickets()"
              v-tooltip:top.tooltip="$t('ticketsList.tooltip')"
              >autorenew</span
            >
          </th>
        </tr>
      </thead>
      <tbody v-if="IsMobile && this.viewLoader && this.list.length">
        <MobileCard
          v-for="(item, keyItem) in this.list"
          :key="keyItem"
          :titles="['subject']"
          :item="item"
          translation-path="ticketsList.CrossConnect"
        >
          <template #url-label>
            <span
              @click="goToPage(componentNameIncident, item.ticketNumber)"
              v-if="
                item.cf_servizi === 'Incident' ||
                item.cf_servizi === 'Incident CrossConnect'
              "
            >
              <div class="cdlButton">{{ $t("tickets.details") }}</div>
            </span>
            <span
              @click="goToPage(componentNameChangeRequest, item.ticketNumber)"
              v-else-if="item.cf_servizi === 'ChangeRequest'"
            >
              <div class="cdlButton">{{ $t("tickets.details") }}</div>
            </span>
            <span
              @click="goToPage(componentNameActivation, item.ticketNumber)"
              v-else-if="item.cf_servizi === 'CrossConnect'"
            >
              <div class="cdlButton">{{ $t("tickets.details") }}</div>
            </span>
            <span v-else>
              <div
                class="cdlButton"
                @click="goToPage(componentNameIncident, item.ticketNumber)"
              >
                {{ $t("tickets.details") }}
              </div>
            </span></template
          >
        </MobileCard>
      </tbody>
      <tbody v-else-if="!IsMobile && this.viewLoader && this.list.length">
        <tr
          v-for="(item, keyItem) in this.list"
          :key="keyItem"
          :class="{ odd: keyItem % 2 }"
        >
          <td>
            <span>{{ this.getDate(item.createdTime) }}</span>
          </td>
          <td>
            <span>{{
              item?.cf_short_title ? item?.cf_short_title : item?.subject
            }}</span>
          </td>
          <td>
            <span v-if="item?.cf_servizi === 'CrossConnect'">{{
              $t("tickets.attivazioni_tlc")
            }}</span>
            <span v-else-if="item?.cf_servizi === 'Incident CrossConnect'"
              >Incident</span
            >
            <span v-else>{{ item?.cf_servizi }}</span>
          </td>
          <td>
            <span v-if="item?.cf_sold_solution">{{
              item?.cf_sold_solution
            }}</span>
            <span v-else>-</span>
          </td>
          <td>
            <TicketStatus :status="item.statusType" />
          </td>

          <td>
            <div style="width: 150px; margin: 0 auto">
              <span
                @click="goToPage(componentNameIncident, item.ticketNumber)"
                v-if="
                  item.cf_servizi === 'Incident' ||
                  item.cf_servizi === 'Incident CrossConnect'
                "
              >
                <div class="cdlButton">{{ $t("tickets.details") }}</div>
              </span>
              <span
                @click="goToPage(componentNameChangeRequest, item.ticketNumber)"
                v-else-if="item.cf_servizi === 'ChangeRequest'"
              >
                <div class="cdlButton">{{ $t("tickets.details") }}</div>
              </span>
              <span
                @click="goToPage(componentNameActivation, item.ticketNumber)"
                v-else-if="item.cf_servizi === 'CrossConnect'"
              >
                <div class="cdlButton">{{ $t("tickets.details") }}</div>
              </span>
              <span v-else>
                <div
                  class="cdlButton"
                  @click="goToPage(componentNameIncident, item.ticketNumber)"
                >
                  {{ $t("tickets.details") }}
                </div>
              </span>
            </div>
          </td>
        </tr>
      </tbody>
      <tbody v-else-if="this.viewLoader">
        <tr>
          <td colspan="7" style="text-align: center">
            <span>{{ $t("tickets.noTickets") }}</span>
          </td>
        </tr>
      </tbody>
    </table>
    <div>
      <br /><br />
      <StatusAlert v-if="viewError" status="error" role="alert">
        <template #body>
          <p v-html="$t('tickets.error')"></p>
        </template>
      </StatusAlert>
    </div>
    <paginator
      v-if="totalPage > 1"
      :total-page="totalPage"
      :current-page="currentPage"
      @change-page="this.changePage"
      @prev-page="this.prevPage"
      @next-page="this.nextPage"
    ></paginator>
  </div>
</template>

<script>
import TicketStatus from "@/components/Feature/Ticket/TicketStatus.vue";
import "@/assets/scss/TicketsList.scss";
import "@/assets/scss/Solutions.scss";
import StatusAlert from "@/components/Primitives/Alerts/StatusAlert.vue";
import Paginator from "@/components/Paginator.vue";
import moment from "moment";
import MobileCard from "@/components/Cards/MobileCard.vue";

export default {
  name: "CrossConnectTicketList",
  components: {
    TicketStatus,
    MobileCard,
    StatusAlert,
    Paginator,
  },
  props: {
    list: Array,
    totalCount: Number,
    viewLoader: Boolean,
    viewError: Boolean,
    componentNameIncident: {
      type: String,
      default: "CrossConnectIncidentDetail",
    },
    componentNameChangeRequest: {
      type: String,
      default: "CrossConnectChangeRequestDetail",
    },
    componentNameActivation: {
      type: String,
      default: "CrossConnectActivationDetails",
    },
  },
  data() {
    return {
      pageSize: 10,
      currentPage: 1,
      messageError: "",
      IsMobile: this.$IsMobile(),
    };
  },
  methods: {
    getDate(myTime) {
      return moment(myTime).format("DD-MM-YYYY", this.$i18n.locale, true);
    },
    changePage(page) {
      this.currentPage = page;
      this.$emit("change-page", page);
    },
    nextPage() {
      if (this.currentPage == this.totalPage) {
        return;
      }
      this.currentPage = parseInt(this.currentPage) + 1;
      this.$emit("change-page", this.currentPage);
    },
    prevPage() {
      if (this.currentPage == 1) {
        return;
      }
      this.currentPage = parseInt(this.currentPage) - 1;
      this.$emit("change-page", this.currentPage);
    },
    getTickets() {
      this.$emit("refresh");
    },
    goToPage(component, id) {
      return this.$router.push({
        name: component + this.$i18n.locale,
        params: { id: id },
      });
    },
  },
  computed: {
    totalPage() {
      return Math.ceil(this.totalCount / this.pageSize) > 1
        ? Math.ceil(this.totalCount / this.pageSize)
        : 1;
    },
  },
};
</script>
